var MySizeAssistForm = class extends HTMLElement {
  connectedCallback() {
    if (this._initialized) {
      return;
    }
    this._initialized = true;
    this._form = this.querySelector("form");
    this._result = this.querySelector(".my-size-assist__result");
    this._submitUrl = "https://script.google.com/macros/s/AKfycbwQHDUqHsM4Qt4tDaFfpWxzS9I3bpjys8fBkda0t7V-mC8shHwPh_NTNkd8kbPLR-PyHQ/exec";
    this.addEventListener("click", this._onClick.bind(this));
    this._form?.addEventListener("submit", this._onSubmit.bind(this));
  }
  _onClick(event) {
    const fitButton = event.target.closest("[data-fit-value]");
    if (fitButton) {
      event.preventDefault();
      this._setFitPreference(fitButton.dataset.fitValue);
      return;
    }
    const backButton = event.target.closest("[data-back-dialog]");
    if (backButton) {
      event.preventDefault();
      this._goBack(backButton.dataset.backDialog);
    }
  }
  _setFitPreference(value) {
    const input = this.querySelector("input[name='fit']");
    if (!input) {
      return;
    }
    input.value = value;
    this.querySelectorAll(".my-size-assist__fit-control").forEach((button) => {
      button.classList.toggle("is-active", button.dataset.fitValue === value);
    });
  }
  _goBack(dialogId) {
    const currentDrawer = this.closest("x-drawer");
    if (currentDrawer?.hide) {
      currentDrawer.hide();
    }
    const targetDialog = document.getElementById(dialogId);
    if (targetDialog?.show) {
      targetDialog.show();
    }
  }
  async _onSubmit(event) {
    event.preventDefault();

    if (!this._form || !this._form.checkValidity()) {
      this._form.reportValidity();
      return;
    }

    const formData = new FormData(this._form);
    const userData = {
      gender: formData.get("gender"),
      chest: parseFloat(formData.get("chest")),
      waist: parseFloat(formData.get("waist")),
      height: parseFloat(formData.get("height")),
      fit: formData.get("fit")
    };

    // Store only user-entered details
    localStorage.setItem('mySizeAssistUserData', JSON.stringify(userData));

    if (!this._result) {
      return;
    }

    this._setResult("Finding your recommended size...", true);

    this.dispatchEvent(new CustomEvent("assist-submit", {
      bubbles: true,
      detail: { userData }
    }));
  }
  _setResult(message, success) {
    if (!this._result) {
      return;
    }
    this._result.hidden = false;
    this._result.textContent = message;
    this._result.classList.toggle("my-size-assist__result--success", success);
    this._result.classList.toggle("my-size-assist__result--error", !success);
  }

  _dispatchSuccess(message, summary) {
    this.dispatchEvent(new CustomEvent("assist-success", {
      bubbles: true,
      detail: { message, summary }
    }));
  }

};
if (!window.customElements.get("my-size-assist-form")) {
  window.customElements.define("my-size-assist-form", MySizeAssistForm);
}


class MySizeAssist extends HTMLElement {
  constructor() {
    super();
    this.currentTab = 1;
    this.hasPrefetchedRecommendation = false;
    this.isPrefetchingRecommendation = false;
    this.headers = {
      1: 'Find your recommended size',
      2: 'Scrub Room Shift Fit',
      3: 'Your Recommended Result'
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const drawerId = this.getAttribute('drawer-id');
    const formId = this.getAttribute('form-id');
    
    this.drawer = document.getElementById(drawerId);
    this.headerElement = this.drawer.querySelector('[data-header]');
    this.tabs = this.drawer.querySelectorAll('[data-tab]');
    this.tabButtons = this.drawer.querySelectorAll('[data-tab-button]');
    this.form = this.drawer.querySelector('[data-assist-form]');
    this.summaryContainer = this.drawer.querySelector('[data-assist-summary]');
    
    // Setup drawer open button
    const openButton = document.querySelector(`[data-open-assist-drawer="${drawerId}"]`);
    this.openButton = openButton;
    if (openButton) {
      openButton.addEventListener('click', () => {
        this.handleDrawerOpen();
      });
    }
    
    // Setup tab navigation buttons
    this.tabButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const targetTab = parseInt(button.getAttribute('data-tab-button'));
        this.switchTab(targetTab);
      });
    });

    // Setup form submit handling
    if (this.form) {
      this.form.addEventListener('assist-submit', (event) => {
        const userData = event.detail?.userData;
        if (userData) {
          this.fetchRecommendation(userData);
        }
      });
    }

    // Close button on result tab
    this.drawer.querySelectorAll('[data-close-assist-drawer]').forEach(button => {
      button.addEventListener('click', () => {
        this.drawer.hide();
      });
    });

    // Delete button on result tab
    const deleteButton = this.drawer.querySelector('[data-delete-data]');
    if (deleteButton) {
      deleteButton.addEventListener('click', () => {
        this.deleteData();
      });
    }

    // If user data already exists, prefetch recommendation on page load.
    this.loadSavedUserData();
  }

  loadSavedUserData() {
    const savedData = localStorage.getItem('mySizeAssistUserData');
    if (!savedData) {
      return;
    }

    try {
      const userData = JSON.parse(savedData);
      if (!userData || !userData.gender) {
        return;
      }

      this.isPrefetchingRecommendation = true;
      this.fetchRecommendation(userData).finally(() => {
        this.isPrefetchingRecommendation = false;
      });
    } catch (e) {
      // Ignore invalid data
    }
  }

  handleDrawerOpen() {
    const savedData = localStorage.getItem('mySizeAssistUserData');
    this.drawer.show();

    if (this.hasPrefetchedRecommendation) {
      this.switchTab(3);
      return;
    }

    this.resetToTab1();

    if (!savedData) {
      return;
    }

    try {
      const userData = JSON.parse(savedData);
      if (!userData || !userData.gender) {
        return;
      }

      if (this.form) {
        const formElement = this.form.querySelector('form');
        if (formElement) {
          const genderSelect = formElement.querySelector('select[name="gender"]');
          const chestInput = formElement.querySelector('input[name="chest"]');
          const waistInput = formElement.querySelector('input[name="waist"]');
          const heightInput = formElement.querySelector('input[name="height"]');

          if (genderSelect) genderSelect.value = userData.gender;
          if (chestInput) chestInput.value = userData.chest;
          if (waistInput) waistInput.value = userData.waist;
          if (heightInput) heightInput.value = userData.height;
          const fitRadio = formElement.querySelector(`input[name="fit"][value="${userData.fit}"]`);
          if (fitRadio) {
            fitRadio.checked = true;
            formElement.querySelectorAll('.my-size-assist__fit-control').forEach(button => {
              button.classList.toggle('is-active', button.dataset.fitValue === userData.fit);
            });
          }
        }
      }

      if (!this.hasPrefetchedRecommendation && !this.isPrefetchingRecommendation) {
        this.fetchRecommendation(userData);
      }
    } catch (e) {
      // Ignore invalid data
    }
  }

  switchTab(tabNumber) {
    // Hide all tabs
    this.tabs.forEach(tab => {
      tab.style.display = 'none';
    });
    
    // Show selected tab
    const selectedTab = this.drawer.querySelector(`[data-tab="${tabNumber}"]`);
    if (selectedTab) {
      selectedTab.style.display = 'block';
      this.currentTab = tabNumber;
      
      // Update header
      if (this.headers[tabNumber]) {
        this.headerElement.textContent = this.headers[tabNumber];
      }
    }
  }

  resetToTab1() {
    this.switchTab(1);
  }

  deleteData() {
    // Clear localStorage
    localStorage.removeItem('mySizeAssistUserData');
    this.hasPrefetchedRecommendation = false;

    // Clear form fields
    if (this.form) {
      const formElement = this.form.querySelector('form');
      if (formElement) {
        const genderSelect = formElement.querySelector('select[name="gender"]');
        const chestInput = formElement.querySelector('input[name="chest"]');
        const waistInput = formElement.querySelector('input[name="waist"]');
        const heightInput = formElement.querySelector('input[name="height"]');
        if (genderSelect) genderSelect.value = '';
        if (chestInput) chestInput.value = '';
        if (waistInput) waistInput.value = '';
        if (heightInput) heightInput.value = '';
        const defaultFitRadio = formElement.querySelector('input[name="fit"][value="Standard"]');
        if (defaultFitRadio) defaultFitRadio.checked = true;
        formElement.querySelectorAll('.my-size-assist__fit-control').forEach(button => {
          button.classList.remove('is-active');
        });
        
        // Reset any result messages
        const formResult = formElement.querySelector('.my-size-assist__result');
        if (formResult) {
          formResult.hidden = true;
          formResult.textContent = '';
          formResult.classList.remove('my-size-assist__result--error', 'my-size-assist__result--success');
        }
      }
    }

    // Move to tab 2
    this.switchTab(2);
  }

  getFormMetafields() {
    if (!this.form) {
      return {};
    }

    const formElement = this.form.querySelector('form');
    if (!formElement) {
      return {};
    }

    return {
      brand: formElement.querySelector('input[name="brand"]')?.value || '',
      collection: formElement.querySelector('input[name="collection"]')?.value || '',
      garmentType: formElement.querySelector('input[name="garment_type"]')?.value?.toLowerCase() || ''
    };
  }

  async fetchRecommendation(userData) {
    const { brand, collection, garmentType } = this.getFormMetafields();
    if (!brand || !collection || !garmentType) {
      this.setResultContent('Unable to determine product details. Please refresh the page.');
      return;
    }

    const payload = {
      brand,
      collection,
      gender: userData.gender,
      garment_type: garmentType,
      fit: userData.fit,
      chest: userData.chest,
      waist: userData.waist,
      height: userData.height
    };

    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbwQHDUqHsM4Qt4tDaFfpWxzS9I3bpjys8fBkda0t7V-mC8shHwPh_NTNkd8kbPLR-PyHQ/exec', {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.status !== 'success') {
        throw new Error(data.message || 'Unable to find size');
      }

      const summary = {
        gender: userData.gender,
        chest: userData.chest,
        waist: userData.waist,
        garmentType,
        fit: userData.fit,
        recommendedTop: data.top_size,
        recommendedBottom: data.bottom_size
      };

      let message = 'Recommended size available.';
      if (garmentType === 'set') {
        message = `Recommended sizes: Top ${data.top_size || 'N/A'}, Bottom ${data.bottom_size || 'N/A'}`;
      } else if (garmentType === 'top') {
        message = `Recommended size: ${data.top_size || 'N/A'}`;
      } else if (garmentType === 'bottom') {
        message = `Recommended size: ${data.bottom_size || 'N/A'}`;
      }

      this.setSummaryContent(summary);
      this.setResultContent(message);
      this.updatePageMessage(message);
      this.switchTab(3);
      this.hasPrefetchedRecommendation = true;
      this.isPrefetchingRecommendation = false;
    } catch (error) {
      this.isPrefetchingRecommendation = false;
      const message = error.message || 'Unable to fetch size recommendation.';
      this.displayError(message);
      this.switchTab(2);
    }
  }

  displayError(message) {
    if (this.form) {
      const formResult = this.form.querySelector('.my-size-assist__result');
      if (formResult) {
        formResult.hidden = false;
        formResult.textContent = message;
        formResult.classList.add('my-size-assist__result--error');
        formResult.classList.remove('my-size-assist__result--success');
      }
    }
    this.updatePageMessage(message);
    this.setResultContent(message);
  }

  // Method to populate result tab (can be called from outside)
  setResultContent(content) {
    const resultTab = this.drawer.querySelector('[data-result-content]');
    if (resultTab) {
      resultTab.innerHTML = content;
    }
  }

  setSummaryContent(summary) {
    if (!this.summaryContainer) {
      return;
    }
    let html = `
      <div class="my-size-assist__summary-item">
        <span class="my-size-assist__summary-label">Gender :</span>
        <span class="my-size-assist__summary-value">${summary.gender}</span>
      </div>`;

    if (summary.garmentType === 'set') {
      html += `
      <div class="my-size-assist__summary-item">
        <span class="my-size-assist__summary-label">Chest Size :</span>
        <span class="my-size-assist__summary-value">${summary.chest}</span>
      </div>
      <div class="my-size-assist__summary-item">
        <span class="my-size-assist__summary-label">Waist Size :</span>
        <span class="my-size-assist__summary-value">${summary.waist}</span>
      </div>`;
    } else if (summary.garmentType === 'top') {
      html += `
      <div class="my-size-assist__summary-item">
        <span class="my-size-assist__summary-label">Chest Size :</span>
        <span class="my-size-assist__summary-value">${summary.chest}</span>
      </div>`;
    } else if (summary.garmentType === 'bottom') {
      html += `
      <div class="my-size-assist__summary-item">
        <span class="my-size-assist__summary-label">Waist Size :</span>
        <span class="my-size-assist__summary-value">${summary.waist}</span>
      </div>`;
    }

    html += `
      <div class="my-size-assist__summary-item">
        <span class="my-size-assist__summary-label">Fit preference :</span>
        <span class="my-size-assist__summary-value">${summary.fit}</span>
      </div>
    `;

    this.summaryContainer.innerHTML = html;
  }

  updatePageMessage(message) {
    if (!this.openButton) return;
    
    const parent = this.openButton.parentNode;
    let messageContainer = document.querySelector('.my-size-assist__page-message');

    if (!messageContainer) {
      messageContainer = document.createElement('div');
      messageContainer.className = 'my-size-assist__page-message';
      parent.insertBefore(messageContainer, this.openButton);
    }

    messageContainer.textContent = message;
    messageContainer.removeAttribute('hidden');
    messageContainer.hidden = false;
  }
}

customElements.define('my-size-assist', MySizeAssist);
